module.exports = __webpack_public_path__ + "assets/8ae6e6eb540c4bd9390254c1047496bd.svg";